import { render } from "./PenghargaanPage.vue?vue&type=template&id=d09a6034&scoped=true"
import script from "./PenghargaanPage.vue?vue&type=script&lang=js"
export * from "./PenghargaanPage.vue?vue&type=script&lang=js"

import "./PenghargaanPage.vue?vue&type=style&index=0&id=d09a6034&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d09a6034"]])

export default __exports__